import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false, // default theme
    themes: {
      light: {
        primary: "#516DDC",
        "primary-light": "#8499f0",
        secondary: "#154866",
        "secondary-light": "#4a7ca1",
        accent: "#3A5ECC",

        background: "#f4f7fb",       // equivalent of --color-bg
        surface: "#ffffff",          // --color-surface
        border: "#d3dce6",           // --color-border

        text: "#1b1e23",             // --color-text
        "text-muted": "#6c7380",

        success: "#27ae60",
        warning: "#f39c12",
        error: "#e74c3c",
        info: "#3498db",
        neutral: "#adb5bd",

        overlay: "rgba(0, 0, 0, 0.2)",
      },
      dark: {
        primary: "#154866",
        "primary-light": "#3e6d91",
        secondary: "#516DDC",
        "secondary-light": "#8195f2",
        accent: "#516DDC",

        background: "#051A2E",
        surface: "#0a2236",
        border: "#1e2d40",

        text: "#ffffff",
        "text-muted": "#b0b8c1",

        success: "#2dc98a",
        warning: "#f5a623",
        error: "#ff4d4f",
        info: "#3abaf4",
        neutral: "#8a97a6",

        overlay: "rgba(0, 0, 0, 0.7)",
      },
    },
  },
});
